import React from 'react';

const SvgRw = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="RW_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path id="RW_svg__d" d="M0 14.667h28V20H0z" />
      <filter
        x="-5.4%"
        y="-28.1%"
        width="110.7%"
        height="156.2%"
        filterUnits="objectBoundingBox"
        id="RW_svg__c"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="RW_svg__b" fill="#fff">
        <use xlinkHref="#RW_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#RW_svg__a" />
      <g mask="url(#RW_svg__b)">
        <use fill="#000" filter="url(#RW_svg__c)" xlinkHref="#RW_svg__d" />
        <use fill="#2D754D" xlinkHref="#RW_svg__d" />
      </g>
      <path fill="#25B1EB" mask="url(#RW_svg__b)" d="M0 0h28v9.333H0z" />
      <path
        fill="#FECB2F"
        mask="url(#RW_svg__b)"
        d="M0 9.333h28v5.333H0zM21.333 6l-1.02 1.13.078-1.52-1.521.077L20 4.667l-1.13-1.02 1.52.077-.077-1.521 1.02 1.13 1.02-1.13-.077 1.52 1.521-.077-1.13 1.02 1.13 1.021-1.52-.078.077 1.521z"
      />
    </g>
  </svg>
);

export default SvgRw;
